module.exports = __webpack_public_path__ + "static/img/5.65612aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/mob/5.png
// module id = L+F4
// module chunks = 1